import { withStyles } from '@material-ui/core/styles';
import { TableCell, Theme } from '@material-ui/core';

export const PasslyTableCellHeader = withStyles((theme: Theme) => ({
    root: {
        height: 32,
        border: 'none',
        paddingLeft: 16,
        padding: 0,
        borderRightStyle: 'solid',
        borderRightWidth: 1,
        borderRightColor: theme.tablerow.border,
        borderBottomStyle: 'solid',
        borderBottomWidth: 1,
        borderBottomColor: theme.tablerow.border
    },
}))(TableCell);

export const PasslyTableCellHeaderStart = withStyles((theme: Theme) => ({
    root: {
        height: 32,
        border: 'none',
        paddingLeft: 16,
        padding: 0,
        borderBottomStyle: 'solid',
        borderBottomWidth: 1,
        borderBottomColor: theme.tablerow.border
    },
}))(TableCell);

export const PasslyTableCellHeaderEnd = withStyles((theme: Theme) => ({
    root: {
        height: 32,
        border: 'none',
        borderWidth: 0,
        padding: 0,
        borderBottomStyle: 'solid',
        borderBottomWidth: 1,
        borderBottomColor: theme.tablerow.border
    },
}))(TableCell);
